<!-- AddNewProductComp.vue -->
<template>
  <div>
    <div class="container-nzidoo">
      <div class="card px-0 pt-4 pb-0 mt-3 mb-3">
        <form id="msform" v-if="!loader">
          <!-- Photos Upload Section -->
          <div class="form-card card-body pt-0 px-4 pb-4">
            <div class="row">
              <div class="col-12">
                <h2 class="mb-3">{{ $t(title) }}</h2>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="mb-3 group-input">
                  <input hidden id="pictures-upload" ref="picturesUpload" value="" />
                  <small class="form-text text-muted mt-2">
                    {{ $t("sentence.dragAndDrop") }} {{ $t("general.or") }} {{ $t("sentence.selectFile") }}
                  </small>
                  <vue2Dropzone ref="dropZonePictures" id="pictures" :options="dropzoneOptions"
                    v-on:vdropzone-sending="onPicturesChange" v-on:vdropzone-removed-file="onPictureRemoval"
                    @vdropzone-complete="afterComplete" class="border rounded p-2 bg-light"
                    style="max-height:200px; overflow-y:auto;">
                  </vue2Dropzone>
                  <div v-for="(error, key) in errors" :key="key">
                    <small v-if="key.startsWith('pictures')" class="text-danger">
                      {{ error[0] }}
                    </small>
                  </div>
                  <small class="text-danger" v-if="errors.old_pictures">{{ errors.old_pictures[0] }}</small>
                </div>
              </div>
            </div>
          </div>

          <!-- Product Name Section -->
          <div class="form-card card-body p-4">
            <div class="row">
              <div class="col-12">
                <div class="mb-3 group-input">
                  <input id="name" name="name" type="text" class="name form-control" v-model.trim="formData.name"
                    :placeholder="$t('ecommerce.product.name-placeholder')" aria-label="Product name" />
                  <small class="text-danger" v-if="errors.name">{{ errors.name[0] }}</small>
                </div>
              </div>
            </div>
          </div>

          <!-- Description and Category Section -->
          <div class="form-card card-body p-4">
            <div class="row">
              <div class="col-12">
                <div class="group-input mb-4">
                  <textarea id="description" class="form-control shadow-sm" rows="4" v-model.trim="formData.description"
                    :placeholder="$t('ecommerce.product.description-placeholder') || 'Ex: Très bon iPhone avec 2Go RAM, 128Go'">
                  </textarea>
                  <small class="text-danger" v-if="errors.description">{{ errors.description[0] }}</small>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="group-input mb-4">
                  <SelectCategories :options="optionsCategories" :selected-category="formData.category"
                    @selected="onCategorySelected" @attributes="onAttributesSelected" />
                  <input hidden="hidden" ref="goNext" class="goNext" />
                  <small class="text-danger" v-if="errors.category_id">{{ errors.category_id[0] }}</small>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="group-input mb-4">
                  <vSelect id="state" :options="optionsStatus" v-model="formData.state"
                    :placeholder="$t('ecommerce.product.state-placeholder')" class="custom-vselect shadow-sm" />
                  <small class="text-danger" v-if="errors.state">{{ errors.state[0] }}</small>
                </div>
              </div>
            </div>
          </div>

          <!-- Pricing and Sales Section -->
          <div class="form-card card-body p-4">
            <div class="row">
              <div class="col-12 col-md-8 offset-md-2">
                <div class="alert alert-danger text-center messageError mb-4" role="alert">
                  {{ $t("sentence.fillAllFields") }}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="group-input mb-4">
                  <vSelect id="salesType" :options="options_sale_type" v-model="selectedSalesType"
                    :placeholder="$t('sentence.chooseSalesType')" @input="onSalesTypeChange">
                  </vSelect>
                  <small class="text-danger" v-if="errors.sales_type">{{ errors.sales_type[0] }}</small>
                </div>
              </div>
            </div>

            <!-- Fixed Price -->
            <div class="row" v-show="formData.salesType === 'fixed'">
              <div class="col-12">
                <div class="group-input mb-4">
                  <input type="number" id="fixPrice" class="form-control" v-model.number="formData.fixPrice"
                    :placeholder="$t('ecommerce.fixed-price')" step="0.01" min="0" />
                  <small class="text-danger" v-if="errors.fixed_price">{{ errors.fixed_price[0] }}</small>
                </div>
              </div>
            </div>

            <!-- Starting Price -->
            <div class="row" v-show="formData.salesType === 'auction'">
              <div class="col-12">
                <div class="group-input mb-4">
                  <input type="number" id="startingPrice" class="form-control" v-model.number="formData.startingPrice"
                    :placeholder="$t('ecommerce.product.starting-price')" step="0.01" min="0" />
                  <small class="text-danger" v-if="errors.starting_price">{{ errors.starting_price[0] }}</small>
                </div>
              </div>
            </div>

            <!-- Lowest Price field -->
            <div class="row" v-show="formData.salesType === 'auction'">
              <div class="col-12">
                <div class="group-input mb-4">
                  <input type="number" id="lowestPrice" class="form-control" v-model.number="formData.lowestPrice"
                    :placeholder="$t('ecommerce.product.lowest-price-placeholder')" step="0.01" min="0" />
                  <small class="text-danger" v-if="errors.lowestPrice">{{ errors.lowestPrice[0] }}</small>
                </div>
              </div>
            </div>

            <!-- Duration -->
            <div class="row" v-if="!fixedPriceType">
              <div class="col-12">
                <div class="group-input mb-4">
                  <vSelect id="duration" :options="optionsDuration" v-model="formData.duration"
                    :placeholder="$t('ecommerce.product.duration-placeholder')">
                  </vSelect>
                  <small class="text-danger" v-if="errors.duration">{{ errors.duration[0] }}</small>
                </div>
              </div>
            </div>

            <!-- Quantity -->
            <div class="row" v-show="fixedPriceType">
              <div class="col-12">
                <div class="group-input mb-4">
                  <input type="number" id="quantity" class="form-control" v-model.number="formData.quantity"
                    :placeholder="$t('ecommerce.product.quantity')" min="1" step="1" />
                  <small class="text-danger" v-if="errors.quantity">{{ errors.quantity[0] }}</small>
                </div>
              </div>
            </div>

            <!-- Hidden field for auction quantity -->
            <input v-show="!fixedPriceType" type="hidden" v-model="formData.quantity" />

            <!-- Hidden values -->
            <input hidden id="auctionStyle" :value="$t('ecommerce.auction-style')" />
            <input hidden id="fixedPrice" :value="$t('ecommerce.fixed-price')" />
            <input hidden id="durationValue" :value="$t('product.duration.three-days')" />
          </div>

          <!-- Sale Options Card -->
          <div class="form-card bg-light">
            <div class="p-4 mb-4 shadow-sm rounded-3">
              <div class="text-center mb-4">
                <h2 class="fs-title fw-semibold text-primary">
                  {{ $t("sentence.saleOptions") }}
                </h2>
              </div>

              <!-- Accept Return -->
              <div class="group-input mb-3 px-2">
                <div v-if="user.roles && user.roles.includes('ROLE_SELLER')" class="d-flex align-items-center">
                  <span class="mdi mdi-check-circle text-success me-2"></span>
                  <label class="fw-semibold mb-0">{{ $t("ecommerce.product.acceptReturn") }}</label>
                </div>
                <div v-else class="form-check">
                  <input type="checkbox" id="acceptReturn" class="form-check-input" v-model="formData.acceptReturn"
                    :true-value="true" :false-value="false" />
                  <label for="acceptReturn" class="form-check-label">
                    {{ $t("ecommerce.product.acceptReturn") }}
                  </label>
                </div>
              </div>

              <!-- Accept Cash on Delivery -->
              <div class="group-input px-2">
                <div class="form-check">
                  <input type="checkbox" id="acceptCashOnDelivery" class="form-check-input"
                    v-model="formData.acceptCashOnDelivery" :true-value="true" :false-value="false" />
                  <label for="acceptCashOnDelivery" class="form-check-label">
                    {{ $t("ecommerce.product.acceptCashOnDelivery") }}
                  </label>
                </div>
              </div>
            </div>
            <SalesCostCard />
          </div>
          <!-- Preview and Submit Section -->
          <div class="form-card card-body p-4">
            <div class="d-flex col-12 justify-content-center justify-content-md-end">
              <button type="button" class="btn btn-site btn-primary" @click="submit()" :disabled="loader">
                {{ $t("action.submit") }}
              </button>
            </div>
          </div>

        </form>
        <LoadingSpinner v-else />
      </div>
    </div>

    <notifications style="top:5%;" width="35%" group="success" position="top center" />
    <notifications style="top:5%;" width="35%" group="error" position="top center" />
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import config from "@/config.js";
import Helper from '@/services/helper';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import SelectCategories from "@/components/templates/SelectCategories.vue";
import SalesCostCard from "@/components/add-product/SalesCostCard.vue";
import LoadingSpinner from "@/components/templates/LoadingSpinner.vue";

export default {
  name: "AddNewProductComp",
  components: {
    vue2Dropzone,
    SelectCategories,
    SalesCostCard,
    LoadingSpinner,
    vSelect,
  },
  props: {
    title: {
      type: String,
      default: "sentence.tellUsWhatYouAreSelling"
    },
    mode: {
      type: String,
      default: "sell", // or "resell"
    }
  },
  data() {
    return {
      formData: {
        name: "",
        description: "",
        category: "",
        categoryName: "",
        pictures: [],
        salesType: "",
        fixPrice: null,
        buyItNowPrice: null,
        lowestPrice: null,
        startingPrice: null,
        quantity: 1,
        state: "",
        duration: "",
        attributes: {},
        acceptOffers: false,
        acceptCashOnDelivery: false,
        acceptReturn: true,
        deliveryCost: null,
        deliveryTime: null,
      },
      user: {
        roles: [],
      },
      categories: [],
      optionsCategories: [],
      options_sale_type: [],
      optionsStatus: [],
      optionsDuration: [],
      errors: {},
      fixedPriceType: false,
      imagePreview: [],
      loader: false,
      dropzoneOptions: {
        url: "#",
        thumbnailWidth: 150,
        maxFilesize: 4,
        dictDefaultMessage: "📸 Ajoute des photos",
        headers: { "My-Awesome-Header": "header value" },
        addRemoveLinks: true,
        duplicateCheck: true,
      },
    };
  },
  computed: {
    // Computed property for sales type selection
    selectedSalesType: {
      get() {
        if (this.formData.salesType==='auction') {
          return this.$t("ecommerce.auction-style");
        } else if (this.formData.salesType==='fixed') {
          return this.$t("ecommerce.fixed-price");
        }
        return "";
      },
      set(value) {
        // This setter is called when v-select changes
        if (value===this.$t("ecommerce.auction-style")) {
          this.formData.salesType="auction";
          this.fixedPriceType=false;
        } else if (value===this.$t("ecommerce.fixed-price")) {
          this.formData.salesType="fixed";
          this.fixedPriceType=true;
        }
      }
    }
  },
  mounted() {
    // Initialize translated options
    this.options_sale_type=[
      this.$t("ecommerce.auction-style"),
      this.$t("ecommerce.fixed-price"),
    ];

    this.optionsStatus=[
      this.$t("product.state.new-in-packaging"),
      this.$t("product.state.new"),
      this.$t("product.state.very-good"),
      this.$t("product.state.good"),
      this.$t("product.state.old"),
    ];

    this.optionsDuration=[
      this.$t("product.duration.three-days"),
      this.$t("product.duration.five-days"),
      this.$t("product.duration.seven-days"),
      this.$t("product.duration.ten-days"),
    ];

    this.getCategories();
    this.loadUserData();

    // Default setup
    if (!this.formData.salesType) {
      this.fixedPriceType=false;
    }

    // Check if we are in edit mode
    if (this.$route.params.id) {
      this.loader=true;
      this.loadProductData(this.$route.params.id)
        .finally(() => {
          this.loader=false;
        });
    }
  },
  methods: {
    onSalesTypeChange(value) {
      // Additional handler if needed for side effects
      console.log('Sales type changed to:', this.formData.salesType, value);
    },
    onAttributesSelected(attrs) {
      this.formData.attributes=attrs;
    },
    loadUserData() {
      const storedUser=localStorage.getItem("user");
      if (storedUser) {
        this.user=JSON.parse(storedUser);
      }
    },
    onCategorySelected(selectedCategory) {
      this.formData.category=selectedCategory.code;
      this.formData.categoryName=selectedCategory.label;
    },
    afterComplete() {
      const files=this.$refs.dropZonePictures.getAcceptedFiles();
      this.formData.pictures=files;
      this.generateImagePreviews();
    },
    onPicturesChange() {
      this.$refs.picturesUpload.value="uploaded";
    },
    onPictureRemoval(file) {
      const files=this.$refs.dropZonePictures
        .getAcceptedFiles()
        .filter((f) => f.dataURL!==file.dataURL);

      this.formData.pictures=files;
      this.generateImagePreviews();

      if (files.length===0) {
        this.$refs.picturesUpload.value="";
      }
    },
    generateImagePreviews() {
      this.imagePreview=[];
      const files=this.formData.pictures;

      if (files&&files.length>0) {
        files.forEach((f) => {
          if (!f.type.match("image.*")) {
            return;
          }

          const reader=new FileReader();
          reader.onload=(e) => {
            this.imagePreview.push(e.target.result);
          };
          reader.readAsDataURL(f);
        });
      }
    },
    getCategories() {
      this.$axios({
        url: "category/list",
        method: "GET",
      })
        .then((response) => {
          this.categories=response.data;
          if (this.categories&&this.categories.length>0) {
            for (let i=0; i<this.categories.length; i++) {
              if (this.categories[i].parent_id===0) {
                this.optionsCategories.push({
                  code: this.categories[i].id,
                  label: this.categories[i].name,
                });
              }
            }
          }
        })
        .catch((err) => console.log(err));
    },
    submit() {
      Helper.scrollToTop(300);

      const isResell=this.mode==='resell';
      const isEdit=!!this.$route.params.id&&!isResell;

      // Determine the URL based on mode
      let url='';
      if (isResell) {
        url=`/product/resell/${this.$route.params.id}`;
      } else if (isEdit) {
        url=`/product/${this.$route.params.id}`;
      } else {
        url='/product/create';
      }

      console.log(this.mode);
      console.log(!!this.$route.params.id);
      console.log(isEdit);
      console.log(isResell);
      console.log(url);

      const formData=new FormData();

      // Use PUT if editing
      if (isEdit) formData.append('_method', 'PUT');

      this.loader=true;

      formData.append("name", this.formData.name);
      formData.append("description", this.formData.description||"");
      formData.append("quantity", parseInt(this.formData.quantity||1));

      if (this.formData.state) formData.append("state", this.formData.state);

      if (this.formData.startingPrice)
        formData.append("starting_price", parseFloat(this.formData.startingPrice).toFixed(2));

      if (this.formData.buyItNowPrice)
        formData.append("buy_it_now_price", parseFloat(this.formData.buyItNowPrice).toFixed(2));

      if (this.formData.lowestPrice)
        formData.append("lowest_price", parseFloat(this.formData.lowestPrice).toFixed(2));

      formData.append("accept_offer", 1);
      formData.append("accept_return", this.formData.acceptReturn? 1:0);
      formData.append("cash_on_delivery", this.formData.acceptCashOnDelivery? 1:0);

      if (this.formData.fixPrice)
        formData.append("fixed_price", parseFloat(this.formData.fixPrice).toFixed(2));

      formData.append("sales_type", this.formData.salesType);
      formData.append("category_id", this.formData.category);

      if (this.formData.duration) {
        const duration=this.formData.duration.split(" ")[0];
        formData.append("duration", parseInt(duration));
      }

      // Handle pictures
      if ((isEdit||isResell)&&this.$refs.dropZonePictures) {
        const dropzoneFiles=this.$refs.dropZonePictures.dropzone.files;
        const oldPictures=[];
        let newPictureIndex=0;

        dropzoneFiles.forEach(file => {
          if (file.isExisting) {
            const base=config.storageUrl||config.apiUrl;
            let picturePath=file.dataURL.replace(base+'/', '');
            picturePath=picturePath.replace(/^\//, '');
            oldPictures.push(picturePath);
          } else if (file.accepted) {
            formData.append(`pictures[${newPictureIndex}]`, file);
            newPictureIndex++;
          }
        });

        if (oldPictures.length>0) formData.append("old_pictures[]", JSON.stringify(oldPictures));
      } else if (this.formData.pictures&&this.formData.pictures.length>0) {
        this.formData.pictures.forEach((pic, i) => {
          formData.append(`pictures[${i}]`, pic);
        });
      }

      // Handle attributes
      if (this.formData.attributes&&Object.keys(this.formData.attributes).length>0) {
        const arrayAttributes=[];
        for (const key in this.formData.attributes) {
          for (const subKey in this.formData.attributes[key]) {
            if (this.formData.attributes[key][subKey]?.length>0) {
              arrayAttributes.push({
                attribute_id: subKey,
                value: this.formData.attributes[key][subKey],
              });
            }
          }
        }
        if (arrayAttributes.length>0) formData.append("attributes[]", JSON.stringify(arrayAttributes));
      }

      if (this.formData.deliveryTime)
        formData.append("delivery_time", parseFloat(this.formData.deliveryTime));

      if (this.formData.deliveryCost)
        formData.append("delivery_cost", parseFloat(this.formData.deliveryCost));

      // Axios POST request
      this.$axios.post(url, formData, { headers: { "Content-Type": "multipart/form-data" } })
        .then((response) => {
          const data=response.data;
          this.loader=false;
          this.$notify({
            group: "success",
            title: isEdit||isResell? 'Produit mis à jour !':'Produit créé !',
            text: isEdit||isResell
              ? 'Le produit a été modifié avec succès.'
              :'Produit créé avec succès !',
            type: "success",
          });
          this.errors={};
          const id=data.data?.value;

          this.$router.push({ name: "BoostPlanManagementAfterCreate", params: { id } });
        })
        .catch(err => {
          this.loader=false;
          console.error(err);

          let errorMessage=err.response.message||'Une erreur est survenue lors de l\'ajout du produit, veuillez réessayer.';
          if (err.response&&err.response.data&&err.response.data.data) {
            this.errors=err.response.data.data;
            this.reinjectDropzoneFiles();
          }

          this.$notify({
            group: "error",
            title: 'Erreur!',
            text: errorMessage,
            type: "error",
          });
        });
    },

    async loadProductData(id) {
      try {
        const response=await this.$axios.get(`product/get/${id}`);
        const product=response.data;

        this.formData.name=product.name||"";
        this.formData.description=product.description||"";
        this.formData.quantity=product.quantity||1;
        this.formData.category=product.category_id||"";
        this.formData.categoryName=product.category?.name||"";
        this.formData.state=product.state||this.$t("product.state.good");

        if (product.sales_type==="fixed") {
          this.formData.salesType="fixed";
          this.fixedPriceType=true;
          this.formData.fixPrice=product.fixed_price||null;
        } else {
          this.formData.salesType="auction";
          this.fixedPriceType=false;
          this.formData.startingPrice=product.starting_price||null;
          this.formData.lowestPrice=product.lowest_price||null;
        }

        this.formData.acceptOffers=product.accept_offer===1;
        this.formData.acceptReturn=product.accept_return===1;
        this.formData.acceptCashOnDelivery=product.cash_on_delivery===1;
        this.formData.duration=`${product.duration} ${this.$t("product.duration.days")}`;

        const base=config.storageUrl||config.apiUrl;
        if (product.pictures&&product.pictures.length>0) {
          this.imagePreview=product.pictures.map(pic => `${base}/${pic}`);
          this.formData.pictures=this.imagePreview;
        }

        const waitForDropzone=() => {
          const dropRef=this.$refs.dropZonePictures;
          if (dropRef&&dropRef.dropzone) {
            const dropzone=dropRef.dropzone;
            dropzone.removeAllFiles(true);

            if (product.pictures&&product.pictures.length>0) {
              const base=config.storageUrl||config.apiUrl;

              product.pictures.forEach((pic) => {
                const imageUrl=`${base}/${pic}`;
                const mockFile={
                  name: pic.split('/').pop(),
                  size: 12345,
                  accepted: true,
                  dataURL: imageUrl,
                  isExisting: true,
                };

                dropzone.emit("addedfile", mockFile);
                dropzone.emit("thumbnail", mockFile, imageUrl);
                dropzone.emit("complete", mockFile);
                dropzone.emit("success", mockFile);

                const previewElement=mockFile.previewElement;
                if (previewElement) {
                  previewElement.classList.add("col-2");
                  previewElement.style.margin="5px";
                }

                dropzone.files.push(mockFile);
              });
            }
          } else {
            setTimeout(waitForDropzone, 100);
          }
        };

        waitForDropzone();
        console.log("✅ Product loaded for edit:", this.formData);
      } catch (error) {
        console.error("❌ Error loading product:", error);
      }
    },
    reinjectDropzoneFiles() {
      const dropzone=this.$refs.dropZonePictures.dropzone;
      dropzone.removeAllFiles(true);

      if (this.formData.pictures&&this.formData.pictures.length>0) {
        this.formData.pictures.forEach(file => {
          const mockFile=file;

          if (!mockFile.dataURL) {
            const reader=new FileReader();
            reader.onload=(e) => {
              mockFile.dataURL=e.target.result;
              dropzone.emit("addedfile", mockFile);
              dropzone.emit("thumbnail", mockFile, mockFile.dataURL);
              dropzone.files.push(mockFile);
            };
            reader.readAsDataURL(mockFile);
          } else {
            dropzone.emit("addedfile", mockFile);
            dropzone.emit("thumbnail", mockFile, mockFile.dataURL);
            dropzone.files.push(mockFile);
          }

          dropzone.emit("complete", mockFile);
          dropzone.emit("success", mockFile);
        });
      }
    },
  },
};
</script>

<style scoped>
.fs-title {
  color: var(--color-nz);
  font-weight: 600;
  font-size: 1.5rem;
}

/* Step text */
.steps {
  color: var(--gray-500);
  font-size: 1.25rem;
  font-weight: 500;
}

input.next {
  margin-top: 5% !important;
}

input.previous {
  margin-top: 5% !important;
}

.messageError {
  display: none;
}

#heading {
  text-transform: uppercase;
  color: var(--color-nz);
  font-weight: normal;
}

#msform {
  text-align: center;
  position: relative;
  /* margin-top: 20px; */
  min-height: 600px;
}

#msform fieldset {
  background: white;
  border: 0 none;
  border-radius: 0.5rem;
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  /* margin-top: 8%; */
  margin-top: 50px;
  margin-bottom: 50px;
  position: relative;
}

.form-card {
  text-align: left;
  background: white;
  border-radius: 8px;
  max-width: 1200px;
  margin: 0 auto;
}

#msform fieldset:not(:first-of-type) {
  display: none;
}

.msform-input,
.msform-textarea {
  padding: 8px 15px 8px 15px;
  border: 1px solid var(--color-c);
  border-radius: 0px;
  margin-bottom: 25px;
  margin-top: 2px;
  width: 100%;
  box-sizing: border-box;
  font-family: montserrat;
  color: var(--color-secondary);
  background-color: #eceff1;
  font-size: 16px;
  letter-spacing: 1px;
}

.msform-input:focus,
.msform-textarea:focus {
  -moz-box-shadow: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border: 1px solid var(--color-nz);
  outline-width: 0;
}

.card {
  z-index: 0;
  border: none;
  position: relative;
}

.fs-title {
  font-size: 25px;
  color: var(--color-nz);
  margin-bottom: 15px;
  font-weight: normal;
  text-align: left;
}

.purple-text {
  color: var(--color-nz);
  font-weight: normal;
}

.steps {
  font-size: 25px;
  color: gray;
  margin-bottom: 10px;
  font-weight: normal;
  text-align: right;
}

.fieldlabels {
  color: gray;
  text-align: left;
}

#progressbar {
  margin-bottom: 30px;
  overflow: hidden;
  color: lightgrey;
}

#progressbar .active {
  color: #e7ab3c;
}


#progressbar #product:before {
  font-family: FontAwesome;
  content: "\f290";
}

#progressbar #categories:before {
  font-family: FontAwesome;
  content: "\f03a";
}

#progressbar #pictures:before {
  font-family: FontAwesome;
  content: "\f030";
}

#progressbar #details:before {
  font-family: FontAwesome;
  content: "\f129";
}

#progressbar #attributes:before {
  font-family: FontAwesome;
  content: "\f1de";
}

#progressbar #description:before {
  font-family: FontAwesome;
  content: "\f02d";
}

#progressbar #delivery:before {
  font-family: FontAwesome;
  content: "\f07a";
}

#progressbar #preview:before {
  font-family: FontAwesome;
  content: "\f03a";
}

#progressbar #confirm:before {
  font-family: FontAwesome;
  content: "\f00c";
}

#progressbar li:before {
  width: 50px;
  height: 50px;
  line-height: 45px;
  display: block;
  font-size: 20px;
  color: white;
  background: lightgray;
  border-radius: 50%;
  margin: 0 auto 10px auto;
  padding: 2px;
}

#progressbar li:after {
  content: "";
  width: 100%;
  height: 2px;
  background: lightgray;
  position: absolute;
  left: 0;
  top: 25px;
  z-index: -1;
}

#progressbar li.active:before,
#progressbar li.active:after {
  background: linear-gradient(135deg, var(--color-nz) 0%, var(--color-nz-200) 100%);
  ;
}

.progress {
  height: 20px;
}

.progress-bar {
  background-color: #e7ab3c !important;
}

.fit-image {
  width: 100%;
  object-fit: cover;
}

/* Tooltip container */
.tooltipelement {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
  /* If you want dots under the hoverable text */
}

/* Tooltipelement text */
.tooltipelement .tooltipelementtext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: white;
  text-align: center;
  padding: 3px 0;
  margin-left: 5px;
  margin-bottom: 10px;
  border-radius: 6px;

  /* Position the tooltipelement text - see examples below! */
  position: absolute;
  z-index: 1;
}

/* Show the tooltipelement text when you mouse over the tooltipelement container */
.tooltipelement:hover .tooltipelementtext {
  visibility: visible;
}

@media (max-width: 768px) {
  #progressbar li {
    list-style-type: none;
    display: none;
    font-size: 15px;
    width: 100%;
    float: left;
    position: relative;
    font-weight: 400;
  }

  #progressbar .active {
    display: block;
  }
}

@media (min-width: 768px) {
  #progressbar li {
    list-style-type: none;
    font-size: 15px;
    width: 11.1%;
    float: left;
    position: relative;
    font-weight: 400;
  }
}

/* smaller devices tweaks */
@media (max-width: 576px) {
  .fs-title {
    font-size: 1.25rem;
    text-align: center;
  }

  .steps {
    font-size: 1rem;
    text-align: center;
  }

  .action-button {
    width: 100%;
  }

  .messageError {
    font-size: 0.95rem;
  }

  #msform fieldset {
    margin-top: 0px;
    margin-bottom: 0px;
  }
}

@import "https://unpkg.com/vue-select@latest/dist/vue-select.css";

/* Base card style */
.form-card {
  border-radius: 10px;
}

/* ============================= */
/* Base Input, Textarea, Select  */
/* ============================= */
.msform-input,
.form-control,
textarea,
.vs__dropdown-toggle {
  background-color: #f9fbfd;
  border: 1px solid #cfd8e3;
  font-size: 1.05rem;
  border-radius: 10px;
  width: 100%;
  height: 56px;
  transition: all 0.2s ease-in-out;
  line-height: 1.4;
  color: var(--color-3);
}

/* ============================= */
/* Textarea                      */
/* ============================= */
textarea {
  resize: vertical;
  min-height: 140px;
  padding: 0.9rem 1rem;
  line-height: 1.6;
  height: auto;
}

/* ============================= */
/* v-select outer box            */
/* ============================= */
.vs__dropdown-toggle {
  min-height: 56px;
  display: flex;
  align-items: center;
  border-radius: 10px;
  background-color: #f9fbfd;
  border: 1px solid #cfd8e3;
  padding: 0 0.5rem;
}

/* Remove default shadows and borders when focused */
.vs__dropdown-toggle:focus,
.vs__dropdown-toggle.vs__open {
  border-color: var(--color-nz);
  box-shadow: 0 0 0 0.2rem rgba(73, 150, 247, 0.15);
  background-color: white;
}

/* ============================= */
/* v-select inner input field    */
/* ============================= */
.vs__search {
  border: none !important;
  border-color: transparent !important;
  background: transparent !important;
  outline: none !important;
  box-shadow: none !important;
  height: 100%;
  font-size: 1.05rem;
  color: var(--color-3);
  margin: 0 !important;
  padding: 0 !important;
}

/* Selected text inside v-select */
.vs__selected {
  font-size: 1.05rem;
  color: var(--color-3);
  padding: 0 0.25rem;
}

/* Dropdown items (open list) */
.vs__dropdown-menu {
  border-radius: 10px;
  font-size: 1.05rem;
}

/* ============================= */
/* Dropzone                      */
/* ============================= */
.vue-dropzone {
  border-radius: 10px;
  min-height: 170px;
  font-size: 1.05rem;
}

/* ============================= */
/* Buttons                       */
/* ============================= */
.action-button {
  min-width: 120px;
  height: 54px;
  font-size: 1.1rem;
  border-radius: 8px;
  font-weight: 600;
}

/* ============================= */
/* Focus state for all inputs    */
/* ============================= */
.msform-input:focus,
.form-control:focus,
textarea:focus {
  outline: none;
  border-color: var(--color-nz);
  box-shadow: 0 0 0 0.2rem rgba(73, 150, 247, 0.15);
  background-color: white;
}

/* ============================= */
/* Mobile view adjustments       */
/* ============================= */
@media (max-width: 576px) {

  .msform-input,
  .form-control,
  .vs__dropdown-toggle {
    height: 64px;
    font-size: 1.1rem;
  }

  textarea {
    min-height: 160px;
    font-size: 1.1rem;
  }

  .action-button {
    width: 100%;
    font-size: 1.1rem;
    height: 60px;
  }

  .vue-dropzone {
    min-height: 200px;
    font-size: 1.1rem;
  }

  .group-input {
    margin-bottom: 1.5rem;
  }

  .form-card {
    padding: 1.25rem !important;
  }
}

#opaque {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: black;
  filter: alpha(opacity=30);
  opacity: 0.3;
}

* html #opaque {
  position: absolute;
}

#opaque,
.loader {
  transition: opacity 0.3s ease-in-out;
}
</style>
